module.exports = __webpack_public_path__ + "img/banner7.279bd7dd.jpg";